import { HttpRequest, HttpEvent, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { finalize } from 'rxjs/operators';

import { inject } from '@angular/core';

export const loaderInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    var loaderService = inject(LoaderService);
    loaderService.show();
    return next(request).pipe(
        finalize(() => {
            loaderService.hide();
        })
    );
}